import { DocumentType } from '~/constants/documentType';
import type { CustomerRequestParams } from '~/services/modules/quotes/types';

/** `2000-05-15T00:00:00.000Z` (ou `2000-05-15`) → `15/05/2000`. Vazio se não der. */
export function isoToBirthDateMask(iso: string | null | undefined): string {
  if (!iso) return '';
  const date = new Date(iso.length === 10 ? `${iso}T00:00:00.000Z` : iso);
  if (Number.isNaN(date.getTime())) return '';
  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  return `${day}/${month}/${date.getUTCFullYear()}`;
}

/** `15/05/2000` → `2000-05-15T00:00:00.000Z`. Vazio se a data não for completa/válida. */
export function birthDateMaskToIso(masked: string | null | undefined): string {
  if (!masked || masked.length !== 10) return '';
  const [day, month, year] = masked.split('/').map(Number);
  if (!day || !month || !year) return '';
  const date = new Date(Date.UTC(year, month - 1, day));
  if (date.getUTCDate() !== day || date.getUTCMonth() !== month - 1 || date.getUTCFullYear() !== year) return '';
  return date.toISOString();
}

export type HolderFormValues = {
  holderName: string;
  holderDocument: string;
  holderBirthDate: string;
  holderPhone: string;
  holderEmail: string;
};

/**
 * Monta o corpo de `PUT /v2/Quotes/{quoteHash}/customer`
 * (`UpdateQuoteCustomerViewModel`) a partir do bloco «Dados do titular».
 *
 * O schema da API **não** tem `gender`: o género só é aceite na criação da
 * cotação (`CreateQuoteCustomerViewModel`), por isso não é reenviado aqui.
 */
export function buildQuoteCustomerPayload(
  values: HolderFormValues,
  extras: { socialName?: string | null; organizationId?: string | null; customerId?: string | null } = {}
): CustomerRequestParams {
  return {
    name: values.holderName.trim(),
    email: values.holderEmail.trim(),
    mobile_phone: values.holderPhone.replace(/\D/g, ''),
    document: values.holderDocument.replace(/\D/g, ''),
    document_type: DocumentType.CPF,
    birthDate: birthDateMaskToIso(values.holderBirthDate),
    ...(extras.socialName ? { social_name: extras.socialName } : {}),
    ...(extras.customerId ? { customer_id: extras.customerId } : {}),
    ...(extras.organizationId ? { organization_id: extras.organizationId } : {})
  };
}
